module.exports = __webpack_public_path__ + "5ee30d97e9a5992734a9407eb640a528.pdf";